import { I18n } from "./i18n";

export const i18nEn: I18n = {
  unsupportedBrowser: "Sorry, unsupported browser. Please upgrade or try a different browser",
  videoDeleted: "Sorry, this video is no longer available",
  videoInPreparation: "This video will be available in a moment<br/>Wait a moment and try to reload the page!",

  sendReport: "Send the report",
  thankYouForSendingReport: "Thank you for sending your error report",
  configurationParsingFailure: "Parsing player configuration failed",
  resourceLoadingFailure: "There was an error while loading scenario elements",
  playbackFailure: "An error has occured",
  runtimeError: "An error has occured",

  subtitles: "Subtitles",
  part: "Part",
  play: "Play",
  pause: "Pause",
  replay: "Replay",
  mute: "Mute",
  unmute: "Unmute",
  share: "Share",
  fullscreen: "Full screen",
  exitFullscreen: "Exit full screen",
  poweredByVintom: "Powered by Vintom",
  licenceAdditionalText: "Read",
  licenceLabel: "player licence",
  linkLicence: "https://player2.vintom.com/player/Vintom_player_terms_of_use.pdf",

  bandwidth: "Bandwidth",
  mbps: "Mbps",

  facebook: "Facebook",
  twitter: "Twitter",

  videoInPreparationLoadingPage: "This video will be available in a moment<br/>Please wait and try to reload the page",
};
